/* eslint-disable react/jsx-tag-spacing */ /* for minified SVGs */
import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const RemoveIcon = ({ title = 'Info', ...props }: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 72 72" {...props}>
    {/* prettier-ignore */}
    <path
      d="M36 2c18.778 0 34 15.222 34 34S54.778 70 36 70 2 54.778 2 36 17.222 2 36 2zM23.587 21.072a2 2 0 00-2.719 2.93l12.174 12.172-11.869 11.87-.101.109a2 2 0 002.93 2.719l11.868-11.87 11.868 11.87.11.102a2 2 0 002.719-2.93l-11.869-11.87 12.174-12.172.102-.11a2 2 0 00-2.93-2.719L35.87 33.346 23.697 21.173z"
      fill="evenodd"
    />
  </CreateIconComponent>
);

export default RemoveIcon;
